import React from "react"

import Layout from "../components/Layout/layout"
import SEO from "../components/SEO/seo"
import BlogsContent from "../components/BlogsContent/blog-content";

const BlogsPage = ({ data }) => {
  let { allArticle: { edges: blogs } } = data
  return (
    <Layout>
      <SEO title="Blogs" />
      <BlogsContent blogs={blogs} />
    </Layout>
  )
}
export default BlogsPage;
export const pageQuery = graphql`
  query {
    allArticle {
      edges {
        node {
          title
          description
          published_at
          slug
          id
        }
      }
    }
  }
`